"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _emotion = require("emotion");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 30px;\n  width: 230px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var selectStyle = (0, _emotion.css)(_templateObject());

var FulfillerSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FulfillerSelector, _PureComponent);

  function FulfillerSelector() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FulfillerSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FulfillerSelector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChange = function (fulfiller) {
      var onFulfillerSelect = _this.props.onFulfillerSelect;
      var newFulfiller = fulfiller || {};
      return onFulfillerSelect && onFulfillerSelect(newFulfiller);
    };

    return _this;
  }

  (0, _createClass2.default)(FulfillerSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fulfillers = _this$props.fulfillers,
          selectedFulfiller = _this$props.selectedFulfiller;
      return fulfillers.length && fulfillers.length > 1 ? _react.default.createElement(_reactComponents.Select, {
        label: "Select a seller",
        value: selectedFulfiller,
        onChange: this.onChange,
        options: fulfillers,
        helpText: "Multiple sellers have configured prices for this SKU.  Select a seller to view their prices.",
        className: selectStyle
      }) : null;
    }
  }]);
  return FulfillerSelector;
}(_react.PureComponent);

exports.default = FulfillerSelector;